module.exports = __webpack_public_path__ + "static/media/bird_fly03.3af10372.gif";